module.exports = __webpack_public_path__ + "img/35.f35e8402.png";